import Api from "./ApiNode";

export default {

    upsertExcelBulkSlineAccount(payload, config) {
        let AllCommonJobList = Api().post("sline-account/import-sline-acc", payload, config);
        return AllCommonJobList;
    },

    clearSlineAccount(payload, config) {
        let AllCommonJobList = Api().post("sline-account/clear-sline-acc", payload, config);
        return AllCommonJobList;
    },
    getPurchaseAccessUsers(payload, config) {
        let AllCommonJobList = Api().post("sline-account/get-all-purchase-appover-user", payload, config);
        return AllCommonJobList;
    },
   
};



// WEBPACK FOOTER //
// ./src/services/SlineAccountServices.js